import type { Except, Merge } from 'type-fest';
import { useField } from '../../../hooks/useField';
import {
    Controlled_ColorInput,
    type Controlled_ColorInputProps,
} from '../../inputs/controlled/Controlled_ColorInput';
import type { StringOrNullableString } from '../../inputs/controlled/types';

export type Form_ColorInputProps<T extends object, N extends boolean> = Merge<
    Except<
        Controlled_ColorInputProps<N>,
        keyof useField.Result<StringOrNullableString<N>>
    >,
    useField.Props<StringOrNullableString<N>, T>
>;

export const Form_ColorInput = <T extends object, N extends boolean>({
    name,
    control,
    onChange,
    ...props
}: Form_ColorInputProps<T, N>) => {
    const fieldProps = useField({
        name,
        control,
        onChange,
    });

    return (
        <Controlled_ColorInput
            {...props}
            {...fieldProps}
        />
    );
};
